// This code is used to add a product details link to the wishlist product card on the wishlist page

document.addEventListener('DOMContentLoaded', function() {
  // Get brand to collection handle mapping (set by theme.liquid)
  const brandToCollectionHandle = window.brandToCollectionHandle || {};
  
  // Helper function to get collection URL from vendor name
  function getCollectionUrlFromVendor(vendorName) {
    if (!vendorName || !brandToCollectionHandle || Object.keys(brandToCollectionHandle).length === 0) {
      return null;
    }
    
    // Try exact match first
    if (brandToCollectionHandle[vendorName]) {
      return '/collections/' + brandToCollectionHandle[vendorName];
    }
    
    // Try with & replaced by &amp;
    const vendorWithAmp = vendorName.replace(/&/g, '&amp;');
    if (brandToCollectionHandle[vendorWithAmp]) {
      return '/collections/' + brandToCollectionHandle[vendorWithAmp];
    }
    
    // Try with &amp; replaced by &
    const vendorWithAnd = vendorName.replace(/&amp;/g, '&');
    if (brandToCollectionHandle[vendorWithAnd]) {
      return '/collections/' + brandToCollectionHandle[vendorWithAnd];
    }
    
    return null;
  }
  
  // Function to make product title and vendor clickable
  function makeTitleAndVendorClickable() {
    const wishlistCards = document.querySelectorAll('.wishlist-grid-view .wishlist-card');
    
    wishlistCards.forEach(function(wishlistCard) {
      // Make product title clickable
      const productTitle = wishlistCard.querySelector('.hulk-product__title');
      if (productTitle && !productTitle.querySelector('a')) {
        const productLink = wishlistCard.querySelector('a[href*="/products/"]');
        if (productLink) {
          const titleText = productTitle.textContent.trim();
          const titleLink = document.createElement('a');
          titleLink.href = productLink.href;
          titleLink.textContent = titleText;
          titleLink.style.textDecoration = 'none';
          titleLink.style.color = 'inherit';
          productTitle.textContent = '';
          productTitle.appendChild(titleLink);
        }
      }
      
      // Make vendor clickable
      const vendorElement = wishlistCard.querySelector('.vendor');
      if (vendorElement && !vendorElement.querySelector('a')) {
        const vendorName = vendorElement.textContent.trim();
        const collectionUrl = getCollectionUrlFromVendor(vendorName);
        
        if (collectionUrl) {
          const vendorLink = document.createElement('a');
          vendorLink.href = collectionUrl;
          vendorLink.textContent = vendorName;
          vendorLink.style.textDecoration = 'none';
          vendorLink.style.color = 'inherit';
          vendorElement.textContent = '';
          vendorElement.appendChild(vendorLink);
        }
      }
    });
  }
  
  function addProductDetailsLinks() {
    const wishlistCards = document.querySelectorAll('.wishlist-grid-view .wishlist-card .wishlist-status');
    
    wishlistCards.forEach(function(wishlistStatus) {
      if (!wishlistStatus.querySelector('.products-details-link')) {
        const wishlistCard = wishlistStatus.closest('.wishlist-card');
        if (!wishlistCard) return;
        
        const productLink = wishlistCard.querySelector('a[href*="/products/"]');
        if (!productLink) return;
        
        const productDetailsLink = document.createElement('p');
        productDetailsLink.className = 'products-details-link hulkThemeColor';
        
        const link = document.createElement('a');
        link.setAttribute('data-goToProduct', '');
        link.className = 'hulkThemeColor';
        link.textContent = 'View Product';
        link.href = productLink.href;
        
        link.addEventListener('click', function(e) {
          e.preventDefault();
          window.location.href = productLink.href;
        });
        
        productDetailsLink.appendChild(link);
        wishlistStatus.appendChild(productDetailsLink);
      }
    });
  }

  // Initialize both functions
  addProductDetailsLinks();
  makeTitleAndVendorClickable();
  
  const observer = new MutationObserver(function() {
    setTimeout(function() {
      addProductDetailsLinks();
      makeTitleAndVendorClickable();
    }, 100);
  });

  const wishlistGridView = document.querySelector('.wishlist-grid-view');
  if (wishlistGridView) {
    observer.observe(wishlistGridView, { childList: true, subtree: true });
  }
}); 